import { _ } from "js/vendor";
import { app } from "js/namespaces";
import * as geom from "js/core/utilities/geom";
import { ContentFrameType } from "common/constants";
import { Shape } from "js/elements/base/Shapes.js";

class Decoration {
    static getDecoration(parentElement, decorationStyles) {
        switch (decorationStyles.type) {
            case "frame":
                return new FrameDecoration(parentElement);
            case "svg":
                return new SVGDecoration(parentElement);
        }
    }

    constructor(parentElement) {
        this.parentElement = parentElement;
    }

    updateLayers() {

    }
}

class FrameDecoration extends Decoration {
    get type() {
        return "frame";
    }

    getDecorationShape(parentSVG, shape) {
        switch (shape) {
            case ContentFrameType.CIRCLE:
                return parentSVG.circle();
            case ContentFrameType.PENTAGON:
            case ContentFrameType.HEXAGON:
            case ContentFrameType.OCTAGON:
                return parentSVG.polygon();
            case ContentFrameType.CALLOUT_BOX:
                return parentSVG.path();
            case ContentFrameType.NONE:
                return null;
            case ContentFrameType.RECT:
            default:
                return parentSVG.rect();
        }
    }

    calcOffset(props) {
        switch (props.styles.shape) {
            case ContentFrameType.CIRCLE:
                this.bounds = props.bounds;
                break;
            case ContentFrameType.RECT:
                this.cornerRadius = props.styles.cornerRadius || 0;
                this.bounds = props.bounds;
                break;
            case ContentFrameType.PENTAGON:
                this.radius = Math.min(props.bounds.width, props.bounds.height) / 2;
                this.bounds = new geom.Rect(props.bounds.centerH - this.radius, props.bounds.centerV - this.radius, props.bounds.width, props.bounds.height);
                break;
            case ContentFrameType.HEXAGON:
                this.radius = Math.min(props.bounds.width, props.bounds.height) / 2;
                this.bounds = new geom.Rect(props.bounds.centerH - this.radius, props.bounds.centerV - this.radius, props.bounds.width, props.bounds.height);
                break;
            case ContentFrameType.OCTAGON:
                this.radius = Math.min(props.bounds.width, props.bounds.height) / 2;
                this.bounds = new geom.Rect(props.bounds.centerH - this.radius, props.bounds.centerV - this.radius, props.bounds.width, props.bounds.height);
                break;
            case ContentFrameType.CALLOUT_BOX:
                this.path = Shape.drawCalloutRect(props.bounds.width / 2, props.bounds.height, props.bounds.width, props.bounds.height, props.styles.cornerRadius || 4, props.styles.tailWidth || 20, props.styles.tailHeight || 20, "bottom");
                this.bounds = props.bounds;
                break;
        }
    }

    layoutDecorationShape(node, props, transition) {
        this.shapeBounds = this.bounds;
        switch (props.styles.shape) {
            case ContentFrameType.CIRCLE:
                node.setBounds(this.bounds, transition);
                this.shapeBounds = this.bounds.square().centerInRect(this.bounds);
                break;
            case ContentFrameType.NONE:
                break;
            case ContentFrameType.RECT:
                node.radius(this.cornerRadius);
                node.setBounds(this.bounds, transition);
                break;
            case ContentFrameType.PENTAGON:
                node.ngon({
                    radius: this.radius,
                    edges: 5
                }).setPosition(this.bounds.left, this.bounds.top);
                this.shapeBounds = new geom.Rect(this.bounds.left, this.bounds.top, this.bounds.square().size);
                break;
            case ContentFrameType.HEXAGON:
                node.ngon({
                    radius: this.radius,
                    edges: 6
                }).setPosition(this.bounds.left, this.bounds.top);
                this.shapeBounds = new geom.Rect(this.bounds.left, this.bounds.top, this.bounds.square().size);
                break;
            case ContentFrameType.OCTAGON:
                node.ngon({
                    radius: this.radius,
                    edges: 8
                }).setPosition(this.bounds.left, this.bounds.top);
                this.shapeBounds = new geom.Rect(this.bounds.left, this.bounds.top, this.bounds.square().size);
                break;
            case ContentFrameType.CALLOUT_BOX:
                node.plot(this.path);
                this.shapeBounds = this.bounds;
                break;
                // case ContentFrameType.CALLOUT_BUBBLE:
                //     Shape.drawCalloutBubble(0, 0, props.bounds.width / 2, this.styles.tailWidth || 20, this.styles.tailHeight || 20, "bottom");
                // break;
        }

        node.style("pointer-events", "none");
        if (props.styles.filter && props.styles.filter !== "none") {
            node.attr("filter", `url(#${props.styles.filter})`);
        }
        if (props.styles.mask && props.styles.mask !== "none") {
            node.attr("mask", `url(#${props.styles.mask})`);
        }
    }

    render(props, transition) {
        if (!this.lastStyles || (this.lastStyles && !_.isEqual(this.lastStyles, props.styles))) {
            // if anything other than just fillColor is different in the new styles, rebuild
            let differentKeys = [];
            if (this.lastStyles) {
                for (let key of Object.keys(props.styles)) {
                    if (props.styles[key] != this.lastStyles[key]) {
                        differentKeys.push(key);
                    }
                }
            }

            if (!this.lastStyles || differentKeys.length > 1 || (differentKeys[0] != "fillColor" || this.lastStyles.fillColor == "none")) {
                // rebuild the decoration
                this.fillNode && this.fillNode.remove();
                this.strokeNode && this.strokeNode.remove();
                this.fillNode = null;
                this.strokeNode = null;

                if (!_.isEmpty(props.styles.strokeColor) && props.styles.strokeColor != "none" && props.styles.strokeWidth != 0) {
                    const shape = this.getDecorationShape(this.parentElement.svg, props.styles.shape);
                    if (shape) {
                        this.strokeNode = shape.attr("id", "strokeDecoration");
                    }
                }

                // if ((!_.isEmpty(props.styles.fillColor) && props.styles.fillColor != "none") || !_.isEmpty(props.styles.filter) || this.strokeNode) {
                if ((!_.isEmpty(props.styles.fillColor) && props.styles.fillColor != "none")) {
                    const shape = this.getDecorationShape(this.parentElement.svg, props.styles.shape);
                    if (shape) {
                        this.fillNode = shape.attr("id", "fillDecoration");
                    }
                }
            }

            this.lastStyles = _.clone(props.styles);
        }

        if (this.fillNode) {
            let fillColor = props.styles.fillColor;
            if (fillColor == "none") {
                fillColor = "backgroundColor";
            }

            let fillStyles = {
                fillColor,
                fillOpacity: props.styles.fillOpacity || 1,
                filter: props.styles.filter
            };
            this.fillNode.applyStyleSheet(fillStyles, props.slideColor, props.backgroundColor, { animate: transition });
            this.calcOffset(props);
            this.layoutDecorationShape(this.fillNode, props, transition);
            this.fillNode.back();
        }
        if (this.strokeNode) {
            let strokeStyles = {
                fill: "none",
                strokeWidth: props.styles.strokeWidth,
                strokeColor: props.styles.strokeColor,
                strokeDash: props.styles.strokeDash,
                strokeOpacity: props.styles.strokeOpacity || 1
            };
            this.strokeNode.applyStyleSheet(strokeStyles, props.slideColor, props.backgroundColor, { animate: transition });
            this.calcOffset(props);
            this.layoutDecorationShape(this.strokeNode, props, transition);
            this.strokeNode.front();
        }

        if (this.effect) {
            this.effect.remove();
        }

        if (!_.isEmpty(props.styles.effect) && props.styles.effect != "none" && !window.hideFilters) {
            this.effect = new SVGDecoration(this.parentElement);
            let effectProps = Object.assign(props, { styles: app.currentTheme.styleSheet.DecorationEffects[props.styles.effect] });
            this.effect.render(effectProps);
        }
    }

    updateLayers() {
        this.fillNode && this.fillNode.back();
        this.strokeNode && this.strokeNode.front();
    }

    remove() {
        if (this.fillNode) {
            this.fillNode.remove();
            this.fillNode = null;
        }
        if (this.strokeNode) {
            this.strokeNode.remove();
            this.strokeNode = null;
        }
        if (this.effect) {
            this.effect.remove();
            this.effect = null;
        }
    }

    getClip() {
        if (this.fillNode) {
            return this.fillNode.clone();
        }
        if (this.strokeNode) {
            return this.strokeNode.clone();
        }
    }
}

class SVGDecoration extends Decoration {
    get type() {
        return "svg";
    }

    render(props) {
        // create a node for the decoration if needed
        if (!this.decorationNode) {
            this.decorationNode = this.parentElement.svg.nested().attr("id", "decoration");
            this.decorationNode.style("pointer-events", "none");
        }

        this.decorationNode.clear();

        let svgDef = props.styles.def;

        svgDef = svgDef.replace(/(\$.*?)(?=[ }'"])/gm, match => {
            return app.currentTheme.styleSheet.variables[match.substr(1)];
        });

        // replace palette colors in svg definition
        if (svgDef.contains("decorationColor")) {
            svgDef = svgDef.replace(/decorationColor/g, "slide");
        }
        svgDef = svgDef.replace(/fill='(.*?)'|stroke='(.*?)'/g, (str, fillColor, strokeColor) => {
            if (fillColor && !fillColor.startsWith("url")) {
                str = str.replace(fillColor, app.currentTheme.palette.getForeColor(fillColor, props.slideColor, props.backgroundColor).toRgbString());
            }
            if (strokeColor) {
                str = str.replace(strokeColor, app.currentTheme.palette.getForeColor(strokeColor, props.slideColor, props.backgroundColor).toRgbString());
            }
            return str;
        });

        // parse the svg def
        let decorationSVG = this.parseSVG(svgDef, props);

        // this.decorationNode.move(this.parentElement.styles.marginLeft, this.parentElement.styles.marginTop);
        this.decorationNode.svg(decorationSVG);
    }

    updateLayers() {
        this.decorationNode.back();
        if (this.decorationNode.next() && this.decorationNode.next().id() === "background") {
            this.decorationNode.forward();
        }
    }

    remove() {
        if (this.decorationNode) {
            this.decorationNode.remove();
            this.decorationNode = null;
        }
    }

    parseSVG(def, props) {
        const svg = def.replace(/#{(.*?)}/g, (match, value) => {
            let expression = "";
            for (let component of value.split(" ")) {
                switch (component) {
                    case "tw":
                        expression += props.element.textBounds.width;
                        break;
                    case "th":
                        expression += props.element.textLayout.size.height;
                        break;
                    case "tl":
                        expression += props.element.innerBounds.left + props.element.textBounds.left;
                        break;
                    case "tr":
                        expression += props.element.innerBounds.left + props.element.textBounds.right;
                        break;
                    case "tc":
                        expression += props.element.innerBounds.left + props.element.innerBounds.width / 2;
                        break;
                    case "tm":
                        expression += props.element.innerBounds.top + props.element.innerBounds.height / 2;
                        break;
                    case "tt":
                        expression += props.element.textBounds.top;
                        break;
                    case "ct":
                        expression += props.bounds.width / 2 - props.element.textBounds.width / 2;
                        break;
                    case "tb":
                        expression += props.element.textBounds.height;
                        break;
                    case "first_char_width":
                        expression += props.layout.lines[0].words[0].glyphWidths[0] * 2;
                        break;
                    case "first_char_left":
                        expression += props.layout.lines[0].words[0].x;
                        break;
                    case "first_char_top":
                        expression += props.layout.lines[0].words[0].y;
                        break;
                    case "last_char_right":
                        expression += _.last(_.last(props.layout.lines).words).x + _.last(_.last(props.layout.lines).words).width;
                        break;
                    case "last_char_top":
                        expression += _.last(_.last(props.layout.lines).words).y;
                        break;
                    case "marginBottom":
                        expression += this.parentElement.styles.marginBottom || 0;
                        break;
                    default:
                        if (component.indexOf("w") > -1) {
                            expression += props.element.bounds.width * (parseInt(component) / 100);
                        } else if (component.indexOf("h") > -1) {
                            expression += props.element.bounds.height * (parseInt(component) / 100);
                        } else {
                            expression += component;
                        }
                }
                expression += " ";
            }

            return eval(expression);
        });
        if (svg == "") {
            return "<g/>";
        } else {
            return svg;
        }
    }

    getClip() {
        return null;
    }
}

export { Decoration, FrameDecoration, SVGDecoration };
